import { Button, TextField } from '@mui/material'
import React, { useState } from 'react'
import { useRequests } from '../requests/useRequests'
import CssBaseline from '@mui/material/CssBaseline'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import { backgroundStyle } from '../styles/background'

interface EmailCodeProps {
  username: string
  code: string | null
  setCode: (s: string) => void
  setIsCodeCorrect: (b: boolean) => void
}

const EmailCode = ({
  username,
  code,
  setCode,
  setIsCodeCorrect
}: EmailCodeProps): JSX.Element => {
  const requestMaker = useRequests()
  const [codeError, setCodeError] = useState<string | null>(null)

  const handleCodeSubmit = async (): Promise<void> => {
    if (codeError !== null) {
      return
    }
    try {
      await requestMaker.validateForgotPasswordCode(username, code!)
      setIsCodeCorrect(true)
    } catch (e) {
      setCodeError('Provided code is not valid')
    }
  }

  return (
    <>
      <form
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault()
            void handleCodeSubmit()
          }
        }}
      >
        <Container component='main' maxWidth='xs'>
          <div style={backgroundStyle} />
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <Typography component='h6' variant='h6'>
              We have just sent you a code to your email address.
            </Typography>
            <TextField
              error={codeError !== null}
              variant='filled'
              helperText={codeError}
              value={code}
              onChange={e => {
                setCodeError(null)
                setCode(e.target.value)
              }}
              margin='normal'
              required
              fullWidth
              id='code'
              label='Code'
              name='code'
              autoComplete='code'
              autoFocus
            />
            <Button
              type='submit'
              fullWidth
              variant='contained'
              sx={{ mt: 3, mb: 2 }}
              disabled={code === null || code?.length === 0}
              onClick={e => {
                e.preventDefault()
                void handleCodeSubmit()
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                  void handleCodeSubmit()
                }
              }}
              tabIndex={0}
            >
              Verify
            </Button>
          </Box>
        </Container>
      </form>
    </>
  )
}

export default EmailCode
